/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![TimerIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAABRklEQVR4nN2UQU7DQAxFh8OAxIYTULGhgETGdljUzkV6HAo9SkPLhhwAyglgAyyAHcgkEaDGk2lSCYkvRZGSyX/jb2ec+2t5kjmQfDReyHlvACDnFsCTzDZSRa3a2G1SiKNjIJl6lPsfu18C8oW+W9sQkBeAUiDyAFCuzfy/+7Co1hbarwiAFK2mZPWEbyIi4UFXQELZfpv/VlQsZMUlV0F3n8pJnBk/JsRHHmW8ElMqQzt/kmmMufeyp+sV0rBmYlfwexSbIniozfWusJUKUG7tCpDfglOSluVb5hXgNRTRexCAMi5jaTaPASw7TxBFRORJLnsDSM5tQCrDvgCA0aEJqKqY9dj9XH/WIOD0LNv2KE8dzF+IeNfFKKHsQD+IB/CznmFuHRHxjp4trebIuVbtusqXjZ/oCOuM6wXId1/P2hr6L/QJ7FAnB5ca9dYAAAAASUVORK5CYII=)
 */
export const TimerIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        fillRule="evenodd"
        d="M12 22a9 9 0 0 0 7.03-14.62l.68-.67a1 1 0 0 0-1.42-1.42l-.67.68A8.96 8.96 0 0 0 13 4.05V3h2a1 1 0 1 0 0-2H9a1 1 0 0 0 0 2h2v1.05c-1.74.2-3.32.88-4.62 1.92l-.67-.68a1 1 0 0 0-1.42 1.42l.68.67A9 9 0 0 0 12 22Zm3.7-11.3a1 1 0 0 0-1.4-1.4l-3 3a1 1 0 0 0 1.4 1.4l3-3Z"
        clipRule="evenodd"
        className={colorClass}
      />
    </svg>
  );
};
